import {
  NavWrapper,
  TopNav,
  NavContainerAbsolut,
  NavContainerSticky,
  Menus,
} from "styles/jss/Navigation.styles";
import { Divider } from "@mui/material";
import { SocialSection } from "components";
import NavLogo from "./NavLogo";
import Navbar from "./Navbar";
import useScrollSpy from "utils/hooks/useScrollSpy";
import LocaleSwitcher from "./LocaleSwitcher";
import Link from "next/link";

export default function Navigation({ socialLinks, logos, navigation }) {
  const sticky = useScrollSpy(false, 500);
  const display = useScrollSpy(false, 300);

  return (
    <>
      <NavContainerSticky display={display ? "flex" : "none"} sticky={sticky}>
      <Link href="/">
              <a>

        <NavLogo logos={logos} sticky={sticky} />
        </a>
        </Link>

        <Navbar display={display} navigation={navigation} />

        {display && (
          <Menus>
            <LocaleSwitcher />
          </Menus>
        )}
      </NavContainerSticky>
      <NavContainerAbsolut sticky={sticky}>
        <NavWrapper>
          <TopNav>
            <Link href="/">
              <a>
                <NavLogo logos={logos} sticky={sticky} />
              </a>
            </Link>

            <SocialSection socialLinks={socialLinks} />
          </TopNav>
          <Divider variant="middle" sx={{ my: "20px" }} />
          <Navbar navigation={navigation} />
        </NavWrapper>
      </NavContainerAbsolut>
    </>
  );
}
